import {
  INJECT_BLOCK_ITEM,
  INJECT_EDIT_CONTEXT,
  INJECT_FIELD_LIST_BLOCKS,
  INJECT_FIELD_LIST_TYPE,
  INJECT_REUSABLE_OPTIONS,
  INJECT_PROVIDER_BLOCKS,
  INJECT_PROVIDER_CONTEXT,
  INJECT_FIELD_USES_PROXY
} from "../helpers/symbols.js";
import { computed, inject } from "#imports";
import { getRuntimeOptionValue } from "#blokkli/helpers/runtimeHelpers";
import {
  OPTIONS
} from "#blokkli-build/runtime-options";
export function defineBlokkli(arg) {
  const [bundle, identifier] = arg.split("::", 2);
  const fieldListType = inject(
    INJECT_FIELD_LIST_TYPE,
    computed(() => "default")
  );
  const siblings = inject(
    INJECT_FIELD_LIST_BLOCKS,
    computed(function() {
      return [];
    })
  );
  const rootBlocks = inject(
    INJECT_PROVIDER_BLOCKS,
    computed(function() {
      return [];
    })
  );
  const item = inject(
    INJECT_BLOCK_ITEM,
    null
  );
  const uuid = item?.value.uuid || "";
  const index = item?.value.index !== void 0 ? item.value.index : computed(() => 0);
  const fromLibraryOptions = inject(
    INJECT_REUSABLE_OPTIONS,
    null
  );
  const editContext = inject(INJECT_EDIT_CONTEXT, null);
  const provider = inject(
    INJECT_PROVIDER_CONTEXT,
    computed(() => null)
  );
  const parentType = computed(() => item?.value.parentType);
  const isEditing = !!item?.value.isEditing;
  const options = computed(() => {
    if (bundle === "from_library") {
      return {
        ...item?.value.options || {},
        ...editContext?.mutatedOptions[uuid] || {}
      };
    }
    const optionKey = bundle === "blokkli_fragment" ? "fragment:" + item?.value.fragmentName + "__default" : identifier;
    const runtimeOptionDefinitions = (editContext?.definitions.runtimeOptions.value || OPTIONS)[optionKey] || {};
    const result = Object.entries(runtimeOptionDefinitions).reduce((acc, [key, v]) => {
      const definition = v;
      if (editContext) {
        const overrideOptions = editContext.mutatedOptions[uuid] || {};
        if (overrideOptions[key] !== void 0 && overrideOptions[key] !== null) {
          acc[key] = getRuntimeOptionValue(definition, overrideOptions[key]);
          return acc;
        }
      }
      if (fromLibraryOptions && fromLibraryOptions.value[key] !== void 0 && fromLibraryOptions.value[key] !== null) {
        acc[key] = getRuntimeOptionValue(
          definition,
          fromLibraryOptions.value[key]
        );
        return acc;
      }
      if (item?.value.options && item.value.options[key] !== void 0 && item.value.options[key] !== null) {
        acc[key] = getRuntimeOptionValue(definition, item.value.options[key]);
        return acc;
      }
      acc[key] = definition[1];
      return acc;
    }, {});
    return result;
  });
  if (import.meta.hot) {
    import.meta.hot.accept("#blokkli-build/runtime-options", () => {
    });
    import.meta.hot.accept("#blokkli/helpers/runtimeHelpers", () => {
    });
  }
  if (editContext?.useBlockRegistration && editContext.dom && bundle !== "from_library" && bundle !== "blokkli_fragment") {
    const isProxyMode = inject(INJECT_FIELD_USES_PROXY, false);
    if (!isProxyMode) {
      editContext.useBlockRegistration(editContext.dom, uuid);
    }
  }
  return {
    uuid,
    index,
    // Must be cast because type of options is inferred automatically.
    options,
    isEditing,
    parentType,
    fieldListType,
    siblings,
    rootBlocks,
    provider
  };
}
